export default "__VITE_ASSET__D$RHMq2R__"